import BossModel from "@/models/BossModel";

export default class AgentBypass extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/agent-bypass';

    /**
     *
     * @type {string}
     */
    static entity = 'dossierAgentBypasses';

    static fields() {
        return {
            id: this.attr(null),
            dossier_id: this.number(null),
            created_by_user_id: this.number(null),
            is_billable_before_product_confirmation: this.boolean(0),
            is_printable_before_product_confirmation: this.boolean(0),
            created_at: this.string(null).nullable(),
        }
    }
}
